// conversion tracking code provided by Ontario Reign
export default function (totalCharge, quantity, card) {
  gtag("event", "conversion", {
    send_to: "AW-328056858/l-H6CLfHy94CEJqAt5wB",
    value: totalCharge,
    currency: "USD",
    transaction_id: card?.id,
    quantity,
  });
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    quantity,
  });
}
